'use client';

import { useEffect } from 'react';

export function TransparentBodyClass() {
  useEffect(() => {
    // Add the transparent background class to body
    document.body.classList.add('embed-avatar-transparent');
    
    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove('embed-avatar-transparent');
    };
  }, []);

  return null;
}
